import axios from 'axios';

import {
  getHeaders,
} from './Utils';

import {
  ENDPOINT_PROJECT, ENDPOINT_PROJECTVERSION,
} from './constants';

export default class Project {
  static getAll() {
    return axios({
      method: 'get',
      headers: getHeaders(),
      url: `${ENDPOINT_PROJECT}?order=lastopened%20DESC`,
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static updateLastLoaded(project) {
    const dataValues = {
      resource: [{
        id: project,
        lastopened: new Date(),
      }],
    };
    return axios({
      method: 'put',
      headers: getHeaders(),
      url: `${ENDPOINT_PROJECT}?id_field=id`,
      data: dataValues,
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static getLatestState(project) {
    if (project) {
      return axios({
        method: 'get',
        headers: getHeaders(),
        url: `${ENDPOINT_PROJECTVERSION}?limit=1&order=date_published%20DESC&filter=project%3D${project.id}`,
      }).catch((err) => {
        throw new Error(err);
      });
    }
  }

  static updateData(project, element, value) {
    const dataValues = {
      resource: [{
        id: project.id,
      }],
    };
    dataValues.resource[0][element] = value;

    return axios({
      method: 'put',
      headers: getHeaders(),
      url: `${ENDPOINT_PROJECT}?id_field=id`,
      data: dataValues,
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static createNew(data) {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_PROJECT}?fields=id,name,owner,category,description,lastopened`,
      data: {
        resource: [
          {
            owner: window.localStorage.getItem('user_id'),
            category: data.category,
            name: data.name,
            description: data.description,
            duration: 'Standardlänge',
            price: 0.00,
            title: 'NEUES PROJEKT',
            rating: 3.4,
          },
        ],
      },
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static createVersion(projectid, gameinfo) {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_PROJECTVERSION}?fields=gamedata,project`,
      data: {
        resource: [
          {
            project: projectid,
            gamedata: gameinfo,
          },
        ],
      },
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static deleteProject(projectId) {
    return axios({
      method: 'delete',
      headers: getHeaders(),
      url: `${ENDPOINT_PROJECT}/${projectId}`,
      data: {
        id_field: 'id',
      },
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static getDetailsByID(projectid) {

  }

  static getVersionsByProjectID(projectid) {

  }

  static generateNew(payload) {

  }

  static generateNewVersion() {

  }

  static saveVersion() {

  }

  static saveProject() {

  }
}



// WEBPACK FOOTER //
// ./src/api/Project.js